<p-panel class="flex flex-col w-full">
  <form [formGroup]="buildForm" (ngSubmit)="onGuardar()" enctype="multipart/form-data" class="space-y-2">

    <p-fieldset legend="Datos Personales" [toggleable]="false"
      styleClass="mb-4 legend-right bg-gray-50 border-round-md border-1 border-gray-300 shadow-1">
      <div class="grid grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12 gap-2">

        <div class="col-span-12 md:col-span-4 lg:col-span-6 xl:col-span-6">
          <label for="CodTipoDocumento" class="label-global">Tipo de Documento</label>
          <div class="w-full flex">
            <p-select [options]="initialService.TipoDocumentoOptions" optionLabel="name" optionValue="code"
              formControlName="CodTipoDocumento" (onChange)="onTipoDocumentoChange($event.value)" [panelStyle]="{ 'background-color': isDarkMode ? '#1f2937' : '#ffffff', 'color': isDarkMode ? '#ffffff' : '#000000',
    'opacity': '1' }" class="w-full border Seleccionerounded px-2 py-1"></p-select>
            @if(buildForm.get('CodTipoDocumento')?.invalid && buildForm.get('CodTipoDocumento')?.touched) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("CodTipoDocumento") }}
            </small>
            }
          </div>
        </div>
        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="NumeroDocumento" class="label-global">Numero Documento</label>
          <div class="w-full flex">
            <input pInputText type="number" formControlName="NumeroDocumento" placeholder="Ingrese Numero Documento"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('NumeroDocumento')?.invalid &&
            (buildForm.get('NumeroDocumento')?.touched ||
            buildForm.get('NumeroDocumento')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("NumeroDocumento") }}
            </small>
            }
          </div>
        </div>
        <div class="col-span-12 md:col-span-4 lg:col-span-2 xl:col-span-2">
          <label for="CodGenero" class="label-global">Genero</label>
          <div class="w-full flex">
            <p-select [options]="initialService.ListaGeneroOptions" optionLabel="name" optionValue="code"
              formControlName="CodGenero" placeholder="" [panelStyle]="{ 'background-color': isDarkMode ? '#1f2937' : '#ffffff', 'color': isDarkMode ? '#ffffff' : '#000000',
    'opacity': '1' }" class="w-full border Seleccionerounded px-2 py-1"></p-select>
            @if(buildForm.get('CodGenero')?.invalid &&
            (buildForm.get('CodGenero')?.touched ||
            buildForm.get('CodGenero')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("CodGenero") }}
            </small>
            }
          </div>
        </div>
        <!-- RAZÓN SOCIAL -->
        <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
          <label for="RazonSocial" class="label-global">{{ labels.RazonSocial }}</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="RazonSocial" placeholder="Ingrese razón social"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('RazonSocial')?.invalid &&
            (buildForm.get('RazonSocial')?.touched ||
            buildForm.get('RazonSocial')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("RazonSocial") }}
            </small>
            }
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
          <label for="PrimerNombre" class="label-global">{{ labels.PrimerNombre }}</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="PrimerNombre" placeholder="Ingrese primer nombre"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('PrimerNombre')?.invalid &&
            (buildForm.get('PrimerNombre')?.touched ||
            buildForm.get('PrimerNombre')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("PrimerNombre") }}
            </small>
            }
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
          <label for="SegundoNombre" class="label-global">{{ labels.SegundoNombre }}</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="SegundoNombre" placeholder="Ingrese segundo nombre"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('SegundoNombre')?.invalid &&
            (buildForm.get('SegundoNombre')?.touched ||
            buildForm.get('SegundoNombre')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("SegundoNombre") }}
            </small>
            }
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
          <label for="PrimerApellido" class="label-global">{{ labels.PrimerApellido }}</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="PrimerApellido" placeholder="Ingrese primer apellido"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('PrimerApellido')?.invalid &&
            (buildForm.get('PrimerApellido')?.touched ||
            buildForm.get('PrimerApellido')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("PrimerApellido") }}
            </small>
            }
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
          <label for="SegundoApellido" class="label-global">{{ labels.SegundoApellido }}</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="SegundoApellido" placeholder="Ingrese segundo apellido"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('SegundoApellido')?.invalid &&
            (buildForm.get('SegundoApellido')?.touched ||
            buildForm.get('SegundoApellido')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("SegundoApellido") }}
            </small>
            }
          </div>
        </div>

      </div>
    </p-fieldset>

    <p-fieldset legend="Datos de Contacto y Ubicación" [toggleable]="false"
      styleClass="mb-4 legend-right bg-gray-50 border-round-md border-1 border-gray-300 shadow-1">
      <div class="grid grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12 gap-2">

        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="Email" class="label-global">Correo Electrónico</label>
          <input pInputText formControlName="Email"
            class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
          @if(buildForm.get('Email')?.invalid &&
          (buildForm.get('Email')?.touched ||
          buildForm.get('Email')?.dirty)) {
          <small
            class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
            {{ formService.getErrorMessage("Email") }}
          </small>
          }
        </div>

        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="Celular" class="label-global">Celular</label>
          <input pInputText type="number" formControlName="Celular"
            class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
          @if(buildForm.get('Celular')?.invalid &&
          (buildForm.get('Celular')?.touched ||
          buildForm.get('Celular')?.dirty)) {
          <small
            class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
            {{ formService.getErrorMessage("Celular") }}
          </small>
          }
        </div>
        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="Direccion" class="label-global">Direccion</label>
          <div class="w-full flex">
            <input pInputText type="text" formControlName="Direccion" placeholder="Direccion"
              class="w-full border rounded px-2 py-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
            @if(buildForm.get('Direccion')?.invalid &&
            (buildForm.get('Direccion')?.touched ||
            buildForm.get('Direccion')?.dirty)) {
            <small
              class="text-red-500 font-medium block mt-1 bg-red-50 px-2 py-1 rounded text-xs border-l-4 border-red-500">
              {{ formService.getErrorMessage("Direccion") }}
            </small>
            }
          </div>
        </div>
        <div class="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
          <label for="CodGlobal" class="label-global">Empresas *</label>
          <p-select [options]="initialService.EmpresaExternoOptions" optionLabel="name" optionValue="code"
            formControlName="CodGlobal" placeholder="Seleccione" [panelStyle]="{ 'background-color': isDarkMode ? '#1f2937' : '#ffffff', 'color': isDarkMode ? '#ffffff' : '#000000',
    'opacity': '1' }" class="w-full border Seleccionerounded px-2 py-1"></p-select>
        </div>
      </div>
    </p-fieldset>
  </form>

  <div class="w-full flex justify-end mt-4 gap-3">

    <p-button label="Guardar" variant="outlined" icon="pi pi-check" (click)="onGuardar()"
      class="px-4 py-2 border-round-lg">
    </p-button>

    <p-button label="Cancelar" variant="outlined" icon="pi pi-times" severity="danger" (click)="onCancelar()"
      class="px-4 py-2 border-round-lg">
    </p-button>

  </div>
</p-panel>